import styles from '../ActivityFilters.module.scss'

import cx from 'classnames'
import ActivityDropDown from './ActivityDropDown'
import { defineMessages, FormattedMessage } from 'react-intl'
import { useDispatch } from 'react-redux'
import get from 'lodash/get'

import useActivityFilter from '../hooks/useActivityFilter'
import {
  clearFilters,
  clearQuery,
  updateFilters,
  updateQuery,
} from '../../../actions/dsl-dive-center-actions'
import { useEffect, useState } from 'react'
import ToScheduleButton from './ToScheduleButton'
import PropTypes from 'prop-types'

const otherActivityFiltersTitle = defineMessages({
  'fun dives': {
    id: 'dive_trip_filter',
    defaultMessage: 'fun dives',
  },
  conservation: {
    id: 'conservation_filter',
    defaultMessage: 'conservation',
  },
  snorkeling: {
    id: 'snorkeling_filter',
    defaultMessage: 'snorkeling',
  },
  social: {
    id: 'social_filter',
    defaultMessage: 'social',
  },
})

const ActivityFilters = ({ activityType, courseFilters }) => {
  const [allIsActive, setAllIsActive] = useState(undefined)
  const dispatch = useDispatch()
  const { filters } = useActivityFilter(activityType, courseFilters)

  useEffect(() => {
    const isActive = filters && !filters.some((filter) => filter.isActive)
    setAllIsActive(isActive)
    if(isActive && activityType === 'courses') {
      dispatch(clearQuery())
    }
  }, [filters])

  const filterHandle = (e, isActive, groupName, filterItems, queryName) => {
    const activeQueries = get(filterItems, '[0].id', [])
    if(groupName === 'all') {
      if(activityType === 'courses') {
        dispatch(clearQuery())
      }
      dispatch(clearFilters({ activityType }))
      setAllIsActive(true)
      return
    }

    if(activityType === 'other') {
      dispatch(
        updateFilters({
          activityType,
          groupName,
          isGroupActive: !isActive,
        }),
      )
      return
    }

    dispatch(
      updateFilters({
        activityType,
        groupName,
        isGroupActive: !isActive,
      }),
    )
    dispatch(
      updateQuery({
        queryName,
        activeQueries,
        isActive: !isActive,
      }),
    )
  }

  return (
    <div className={styles.filterWrapper}>
      <div className={styles.filtersList}>
        <button
          className={cx(styles.filterButton, {
            [styles.active]: allIsActive,
          })}
          value='all'
          onClick={(e) => filterHandle(e, allIsActive, 'all')}
        >
          <FormattedMessage id='all_filter_btn' defaultMessage='all' />
        </button>
        {filters &&
          filters.map((filter, index) => {
            const { items, title, isActive, query_name: queryName } = filter
            return items.length > 1 ? (
              <ActivityDropDown
                activityType={activityType}
                isActive={isActive}
                key={title + index}
                items={items}
                placeholder={title}
                queryName={queryName}
              />
            ) : (
              <button
                key={title + index}
                className={cx(styles.filterButton, {
                  [styles.active]: isActive,
                })}
                value={title}
                onClick={(e) =>
                  filterHandle(e, isActive, title, items, queryName)
                }
              >
                {activityType === 'other' ? (
                  <FormattedMessage {...otherActivityFiltersTitle[title]} />
                ) : (
                  title
                )}
              </button>
            )
          })}
      </div>
      <ToScheduleButton />
    </div>
  )
}

export default ActivityFilters

ActivityFilters.propTypes = {
  activityType: PropTypes.string.isRequired,
  courseFilters: PropTypes.array,
}
